import {WishlistStreamItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/stream.types';
import {TrackingWishlist} from '@aboutyou/legacy-tracking-sdk';
import {useEffect, useRef} from 'react';
import {useTrackPageView} from '../trackingHooks/trackPageView';

export const TrackWishlistPageView = ({
  itemStream,
  isDataFetched,
  isDataFetching,
}: {
  itemStream: WishlistStreamItem[];
  isDataFetching: boolean;
  isDataFetched?: boolean;
}) => {
  const trackWishlistPageView = useTrackPageView();
  const eventSent = useRef(false);

  const triggerEvent = () => {
    if (isDataFetching || eventSent.current) {
      return;
    }

    const items = itemStream
      .map(item => {
        if (item.type?.$case === 'product') {
          const currentProduct = item.type.product.product;
          return {
            item_id: currentProduct.product.id,
          };
        }
        return null;
      })
      .filter(item => item !== null) as TrackingWishlist['items'];
    eventSent.current = true;
    trackWishlistPageView({
      wishlist: {
        items: items.map(item => ({product: {id: item.item_id}})),
      },
    });
  };

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    // on product add to wishlist we have three triggers of this useEffect
    // 1. trigger will have isDataFetching as false which messes up whole logic
    const timer = setTimeout(() => {
      triggerEvent();
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [itemStream, isDataFetched, isDataFetching]);

  return null;
};
